import { EmailSubscription } from './email-subscription';

export default EmailSubscription;
